import React, { useContext, useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  getCorporateClientsList,
  getCorporateClientsListByFilter,
  getCorporateClientsListBySearch,
} from "../../../Services/CorporateClient.service";
import Paper from "@mui/material/Paper";
import {
  Box,
  Container,
  Pagination,
  TablePagination,
  Tooltip,
  Typography,
  Skeleton,
  Checkbox,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import CorpClientInfo from "./CorpInfo/CorpClientInfo";
import Select from "react-select";
import SharedDataContext from "../../../_helper/SharedData";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Breadcrumbs, ToolTip } from "../../../AbstractElements";
import FilterTable from "../../Common/Component/FilterTable";
import {
  CorporateClientFilterColumnsNew,
  CorporateClientFilterColumns,
} from "../../../Data/Configuration/CorporateClient";
import { showAlert } from "../../../Services/Shared.service";
import SearchTable from "../../Common/Component/SearchTable";
import { Row } from "reactstrap";
import SelectedFilter from "../../TripManagement/BookingHistory/SelectedFilter";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTariffSearch } from "../../../_helper/TariffSearchContext/TariffSeachContext";
import airportIcon from "../../../assets/images/tarrifManagement/mdi_local-airport.svg";
import cityIcon from "../../../assets/images/tarrifManagement/mdi_city.svg";

function CorprateClientsList() {
  const {
    cityData,
    globalCityField,
    corpRefresh,
    setShowApiLoader,
    isRefresh,
  } = useContext(SharedDataContext);
  const {
    searchData,
    setSearchData,
    filterData,
    setFilterData,
    filterType,
    setFilterType,
    corpPagination,
    setCorpPagination,
    corpBulkEditMode,
    setCorpBulkEditMode,
    selectedCorpClients,
    setSelectedCorpClients
  } = useTariffSearch();
  const [corpClients, setCorpClients] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [searchData, setSearchData] = useState("");
  // const [filterType, setFilterType] = useState("");
  // const [filterData, setFilterData] = useState([]);
  // const [pagination, setPagination] = useState({ page: 0, rowsPerPage: 7 });
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const prevCityRef = useRef(globalCityField.value?.id);

  // const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  // const {  } = useContext(SharedDataContext);

  // Combined effect: Reset pagination on city change and fetch data
  // Utility to reset page and fetch safely
  const resetPageAndFetch = () => {
    setCorpPagination(prev => {
      if (prev.page === 0) {
        // Already at page 0 → fetch directly
        fetchCorpData();
        return prev;
      }
      // Set page to 0 (first effect will fetch)
      return { ...prev, page: 0 };
    });
  };

  useEffect(() => {
    const cityChanged = prevCityRef.current !== globalCityField.value?.id;
    prevCityRef.current = globalCityField.value?.id;

    // Check if returning from child
    const isReturning = sessionStorage.getItem('corpClientsListNavToChild') === 'true';
    if (isReturning) {
      sessionStorage.removeItem('corpClientsListNavToChild');
      console.log("Returning from child");
      fetchCorpData();
      return;
    }

    // City changed → reset page first
    if (cityChanged) {
      resetPageAndFetch();
      return;
    }

    // Normal fetch when page or rows-per-page changes
    fetchCorpData();
  }, [
    globalCityField.value?.id,
    corpPagination.page,
    corpPagination.rowsPerPage
  ]);

  // Search effect
  useEffect(() => {
    if (!searchData && filterType !== "search") return;
    resetPageAndFetch();
  }, [searchData]);

  // Filter effect
  useEffect(() => {
    if (filterData.length === 0 && filterType !== "filter") return;
    resetPageAndFetch();
  }, [filterData]);


  // const handleCorpClick = (corporateClient) =>{
  //   console.log("Corporate Client Selected",corporateClient);
  //   setCorpClient(corporateClient)
  // }

  // pagenation
  const handleChangePage = (event, newPage) => {
    setCorpPagination((prev) => ({ ...prev, page: newPage }));
  };
  const handleChangeRowsPerPage = (event) => {
    setCorpPagination((prev) => ({
      ...prev,
      page: 0,
      rowsPerPage: parseInt(event.target.value, 10),
    }));
  };
  // const totalPages = Math.floor(count / pagination.rowsPerPage);
  // console.log(totalPages,"count==",count,"pagination", pagination.rowsPerPage,"3243434343")

  let columns = [];

  CorporateClientFilterColumnsNew.map((element) => {
    if (element.value) {
      columns.push({
        value: {
          name: element.name,
          value: element.value,
          type: element.type,
        },
        label: element.name,
      });
    }
  });

  const removeFilter = (index) => {
    const newfilterData = [...filterData];
    newfilterData.splice(index, 1);
    setFilterData(newfilterData);
  };

  // Clear bulk edit mode on component load
  useEffect(() => {
    setCorpBulkEditMode(false);
    setSelectedCorpClients([]);
    sessionStorage.removeItem('corpBulkEditAccess');
  }, []);

  const MAX_CORP_CLIENT_LIMIT = 20;

  const handleCheckboxChange = (client, isChecked) => {
    if (isChecked) {
      if (selectedCorpClients.length >= MAX_CORP_CLIENT_LIMIT) {
        showAlert("warning", `Maximum ${MAX_CORP_CLIENT_LIMIT} corporate clients can be selected`);
        return;
      }
      setSelectedCorpClients([...selectedCorpClients, client]);
    } else {
      setSelectedCorpClients(selectedCorpClients.filter(c => c.id !== client.id));
    }
  };

  const isClientSelected = (clientId) => {
    return selectedCorpClients.some(c => c.id === clientId);
  };

  const fetchCorpData = () => {
    setLoading(true);
    const serviceCityId = globalCityField.value?.id || null;
    let obj = {
      serviceCityId: serviceCityId,
      page: corpPagination.page ,
      size: corpPagination.rowsPerPage,
    };

    if (searchData) {
      obj.name = searchData;
      getCorporateClientsListBySearch(obj)
        .then((result) => {
          setCorpClients(result.data.list);
          setCount(result.data.count);
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (filterData.length > 0 && filterType == "filter") {
      filterData.forEach((d) => {
        // Use filterValues for API (contains ID), values is for display (contains label)
        obj[d.column_name] = d["filterValues"] ? d["filterValues"][0] : d["values"][0];
      });

      getCorporateClientsListByFilter(obj)
        .then((result) => {
          setCorpClients(result.data.list);
          setCount(result.data.count);
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      getCorporateClientsList(obj)
        .then((result) => {
          setCorpClients(result.data.list);
          setCount(result.data.count);
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  function truncateString(str) {
    let num = 20;
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  }

  const serviceCity = [
    {
      cityId: 1,
      cityName: "Delhi",
    },
    {
      cityId: 4,
      cityName: "Bangalore",
    },
    {
      cityId: 32,
      cityName: "Goa",
    },
    {
      cityId: 12,
      cityName: "Amritsar",
    },
  ];
  return (
    <div>
      {/* <Breadcrumbs
        parent="Configuration"
        subParent="Packages"
        mainTitle="Packages"
        span2={
          <FilterTable
            options={columns}
            setFilterData={setFilterData}
            filterData={filterData}
            setSearchData={setSearchData}
            setFilterType={setFilterType}
            pickupTypeData={pickupTypeData}
            clientTypeData={clientTypeData}
          />
        }
        span3={
          <SearchTable
            searchData={searchData}
            setSearchData={setSearchData}
            setFilterData={setFilterData}
            setFilterType={setFilterType}
          />
        }
      /> */}
      {/* <Row className="selected-filter">
        {filterData.map((element, i) => {
          return (
            <SelectedFilter
              key={i}
              element={element}
              index={i}
              removeFilter={removeFilter}
            />
          );
        })}
      </Row> */}
      <Box
        sx={{
          width: "100%",
          overflowY: "hidden",
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {loading || corpClients.length > 0 ? (
            <>
              <TableContainer
                component={Paper}
                aria-label="sticky table"
                sx={{
                  maxHeight: "33vw",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  overflowX: "hidden",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          color: "#626262",
                          fontWeight: "bold",
                          fontSize: "1.11vw",
                          backgroundColor: "#E1F4E4",
                        },
                      }}
                    >
                      {corpBulkEditMode && (
                        <TableCell padding="checkbox" sx={{ width: "80px" }}>
                          <Box sx={{ textAlign: "center" }}>Select ({selectedCorpClients.length}/{MAX_CORP_CLIENT_LIMIT})</Box>
                        </TableCell>
                      )}
                      <TableCell>
                        <Box sx={{ textAlign: "left" }}>Client Name</Box>
                      </TableCell>

                      <TableCell align="left">Contact Person</TableCell>

                      <TableCell align="left">Email</TableCell>

                      <TableCell align="left">Mobile No</TableCell>

                      <TableCell align="center">Service City</TableCell>

                      {/* <TableCell align="center">Ride Type</TableCell> */}

                      <TableCell align="left">Status</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {loading
                      ? [...Array(7)].map((_, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              <Skeleton
                                animation="wave"
                                width="100%"
                                height={30}
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                animation="wave"
                                width="100%"
                                height={30}
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                animation="wave"
                                width="100%"
                                height={30}
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                animation="wave"
                                width="100%"
                                height={30}
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                animation="wave"
                                width="100%"
                                height={30}
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                animation="wave"
                                width="100%"
                                height={30}
                              />
                            </TableCell>
                            <TableCell>
                              <Skeleton
                                animation="wave"
                                width="100%"
                                height={30}
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      : corpClients.map((singleCorpData) => (
                          <TableRow
                            key={singleCorpData.id}
                            onClick={() => {
                              if (corpBulkEditMode) {
                                // Toggle checkbox when in bulk edit mode
                                const isCurrentlySelected = isClientSelected(singleCorpData.id);
                                handleCheckboxChange(singleCorpData, !isCurrentlySelected);
                                return;
                              }
                              // Set flag to preserve pagination when returning
                              sessionStorage.setItem('corpClientsListNavToChild', 'true');
                              navigate(
                                `${process.env.PUBLIC_URL}/tariff_master/view/corp/info/${singleCorpData.id}`
                              );
                            }}
                            sx={{
                              "&:hover": {
                                cursor: "pointer",
                                backgroundColor: "#EBEBEB",
                              },
                              "&:last-child td, &:last-child th": { border: 0 },
                              "& td": { borderBottom: "none" },
                              backgroundColor: isClientSelected(singleCorpData.id) ? "rgba(225, 244, 228, 0.5)" : "inherit",
                            }}
                          >
                            {corpBulkEditMode && (
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isClientSelected(singleCorpData.id)}
                                  onChange={(e) => handleCheckboxChange(singleCorpData, e.target.checked)}
                                  onClick={(e) => e.stopPropagation()}
                                  sx={{
                                    color: "rgba(57, 181, 74, 1)",
                                    "&.Mui-checked": {
                                      color: "rgba(57, 181, 74, 1)",
                                    },
                                  }}
                                />
                              </TableCell>
                            )}
                            <TableCell
                              align="left"
                              sx={{
                                color: "#39B54A",
                                fontSize: "1vw",
                                fontWeight: "600",
                                maxWidth: "13vw",
                              }}
                            >
                              {singleCorpData.companyName}
                            </TableCell>

                            <TableCell
                              align="left"
                              sx={{
                                fontSize: "1vw",
                                color: "black",
                                fontWeight: "bold",
                                maxWidth: "11.6vw",
                              }}
                            >
                              {singleCorpData.contactPerson}
                            </TableCell>

                            <TableCell
                              align="left"
                              sx={{
                                color: "#313131",
                                maxWidth: "13.6vw",
                                textAlign: "left",
                                fontSize: "0.9vw",
                                display: "block",
                                whiteSpace: "normal",
                                overflowWrap: "anywhere",
                                wordBreak: "break-word",
                              }}
                            >
                              {singleCorpData.email}
                            </TableCell>

                            <TableCell
                              align="left"
                              sx={{
                                color: "black",
                                fontWeight: "bold",
                                fontSize: "1vw",
                              }}
                            >
                              {singleCorpData.mobile}
                            </TableCell>

                            <TableCell align="center">
                              <Box
                                sx={{
                                  textAlign: "center",
                                  fontSize: "0.97vw",
                                  color: "#313131",
                                  fontWeight: "400",
                                }}
                              >
                                {singleCorpData.serviceCityName ? singleCorpData.serviceCityName : "-"}
                              </Box>
                            </TableCell>

                            {/* <TableCell align="center">
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "0.5vw",
                                }}
                              >
                                <img
                                  src={
                                    singleCorpData.isAirportClient
                                      ? airportIcon
                                      : cityIcon
                                  }
                                  alt="close"
                                />
                                <Typography
                                  sx={{
                                    fontSize: "1vw",
                                    color: "#313131",
                                    fontWeight: 400,
                                  }}
                                >
                                  {singleCorpData.isAirportClient
                                    ? "Airport"
                                    : "City"}
                                </Typography>
                              </Box>
                            </TableCell> */}
                        <TableCell align="left" sx={{maxWidth: "12vw",}}>
                         <Box
                           sx={{
                            flex: 1,
                            fontSize: "1vw",
                            color: "#313131",
                            fontWeight: "bold",
                          }}
                        >
                          {!singleCorpData.isDeleted ? (
                            <Box
                              sx={{
                                display: "flex",
                                backgroundColor: "#E3F5E1",
                                width: "6.11vw",
                                height: "2.01vw",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                                borderRadius: "6px",
                                padding: "6px",
                                border: "1px solid rgba(116, 206, 106, 1)",
                              }}
                            >
                              <Box
                                sx={{
                                  width: "0.56vw",
                                  height: "0.56vw",
                                  background: "rgba(116, 206, 106, 1)",
                                  borderRadius: "50%",
                                }}
                              />
                              <Typography sx={{ fontSize: "0.97vw" }}>
                                Active
                              </Typography>
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-around",
                                width: "6.11vw",
                                height: "2.01vw",
                                borderRadius: "6px",
                                padding: "6px",
                                backgroundColor: "#ffe5e5", // light red
                                border: "1px solid #cc0000", // darker red border
                              }}
                            >
                              <Box
                                sx={{
                                  width: "0.56vw",
                                  height: "0.56vw",
                                  backgroundColor: "#cc0000",
                                  borderRadius: "50%",
                                }}
                              />
                              <Typography
                                sx={{ fontSize: "0.97vw", color: "#cc0000" }}
                              >
                                InActive
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={count}
                page={corpPagination.page}
                onPageChange={handleChangePage}
                rowsPerPage={corpPagination.rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[7, 10, 25, 50]}
                sx={{
                  "& .MuiTablePagination-toolbar": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 2,
                    textAlign: "center",
                    overflowX: "hidden", 
                  },

                  "& .MuiTablePagination-select": {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    borderRadius: "6px",
                    border: "1px solid #D9D9D9",
                  },

                  "& .MuiTablePagination-actions button": {
                    color: "rgba(112, 112, 112, 1)",
                    transform: "scale(1.3)",
                  },

                  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                    {
                      color: "rgba(98, 98, 98, 1)",
                      fontSize: "0.97vw",
                      textAlign: "center",
                      m: "auto",
                      letterSpacing: "0.02vw",
                    },
                }}
              />
            </>
        ) : (
          <Box
            sx={{
              width: "100%",
              backgroundColor: "white",
              minHeight: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "6px",
            }}
          >
            <Typography sx={{ color: "black" }}>
              No Clients Available
            </Typography>
          </Box>
        )}
      </Box>
    </div>
  );
}

export default CorprateClientsList;
